export const getSupportPhoneLink = (phoneNumber: string) => {
  const cleaned = phoneNumber.replace(/\s+/g, '')
  return 'tel:' + cleaned
}
